// extracted by mini-css-extract-plugin
module.exports = {"logo":"Register_logo__D-IOr","paper":"Register_paper__33imz"};